import productOverview from "@/components/product-overview/product-overview.vue";
import treeTvsi from "@/components/tree-tvsi/tree-tvsi.vue";
import treeExness from "@/components/tree-exness/tree-exness.vue";
import { i18n } from "@/config/i18n";

export default {
    components: { productOverview, treeTvsi, treeExness },

    data() {
        return {
            features: [
                {
                    id: 1,
                    icon: "fas fa-chart-line",
                    title: i18n.global.t("about.partagerVN"),
                    description: i18n.global.t("about.partagerVNDes"),
                },
                {
                    id: 2,
                    icon: "fas fa-globe",
                    title: i18n.global.t("about.cfd"),
                    description: i18n.global.t("about.cfdDes"),
                },
                {
                    id: 3,
                    icon: "fas fa-copy",
                    title: i18n.global.t("about.copy"),
                    description: i18n.global.t("about.copyDes"),
                },
            ],
            chartData: [45, 65, 80, 55, 90],
        };
    },

    mounted() {
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.initCardAnimations();
        setTimeout(() => {
            this.chartData = [60, 75, 85, 70, 95];
        }, 500);
    },

    methods: {
        initCardAnimations() {
            const cards = document.querySelectorAll(".pages__about--card-hover");
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry, index) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => {
                            entry.target.style.opacity = "1";
                            entry.target.style.transform = "translateY(0) scale(1)";
                        }, index * 150);
                    }
                });
            }, { threshold: 0.1, rootMargin: "0px 0px -50px 0px" });

            cards.forEach((card) => {
                card.style.opacity = "0";
                card.style.transform = "translateY(30px) scale(0.95)";
                card.style.transition = "all 0.6s ease-out";
                observer.observe(card);
            });
        },
    },
};
